import { createBms, createLevelSensor, createVeDirect } from "../domain/models";
import { CHANNEL_COUNT } from "../constants/app";

const BMS_CELLS = [3.45, 3.46, 3.44, 3.45];
const BMS_VOLTAGE = parseFloat(BMS_CELLS.reduce((sum, v) => sum + v, 0).toFixed(2));

const mockProfiles = {
  "bms-bridge": {
    type: "BMS",
    typeLabel: "BMS",
    name: "cBerry BMS Bridge",
    address: "0x01",
    category: "Bridges",
    hw: "v1.2",
    firmware: "v2.5.1",
    status: "Needs Update",
    device: createBms({
      id: "bms-bridge",
      name: "BMS Bridge",
      showOnDashboard: false,
      status: "ok",
      nodeId: "bms-bridge",
      metrics: {
        soc: 88,
        soh: 98,
        voltage: BMS_VOLTAGE,
        current: -12.5,
        power: -165,
        cells: BMS_CELLS,
        statusLine: "Discharging",
        timeLeft: "12h 30m left",
        updatedAt: Date.now(),
      },
      controls: { chargeEnabled: true, dischargeEnabled: true },
      faults: [],
    }),
  },
  "ved-bridge": {
    type: "VE.Direct",
    typeLabel: "MPPT",
    name: "cBerry VE.direct Bridge",
    address: "0x05",
    category: "Bridges",
    hw: "v2.1",
    firmware: "v1.8.0",
    status: "OK",
    device: createVeDirect({
      id: "ved-bridge",
      name: "VE.direct Bridge",
      status: "Bulk Charging",
      metrics: { power: 125 },
    }),
  },
  "ewl-1": {
    type: "PDM",
    typeLabel: "I/O",
    subtype: "EWL-810",
    name: "cBerry EWL-810 #1",
    address: "0x20",
    category: "Power",
    hw: "v1.0",
    firmware: "v1.0.0",
    status: "OK",
    channels: Array.from({ length: CHANNEL_COUNT }).map((_, idx) => ({
      index: idx + 1,
      ownerDeviceId: null,
      mode: "Dimming",
      resetBehavior: "Defined Value",
      definedValue: 50,
      turnOnDelay: 0,
      turnOffDelay: 0,
      softFuseEnabled: false,
      currentLimit: null,
      overcurrentDuration: null,
      reaction: "Alarm",
      metrics: { current: 0, fuseState: "ok" },
    })),
  },
  "ewl-2": {
    type: "PDM",
    typeLabel: "I/O",
    subtype: "EWL-810",
    name: "cBerry EWL-810 #2",
    address: "0x21",
    category: "Power",
    hw: "v1.0",
    firmware: "v1.0.0",
    status: "OK",
    channels: Array.from({ length: CHANNEL_COUNT }).map((_, idx) => ({
      index: idx + 1,
      ownerDeviceId: null,
      mode: "Dimming",
      resetBehavior: "Defined Value",
      definedValue: 50,
      turnOnDelay: 0,
      turnOffDelay: 0,
      softFuseEnabled: false,
      currentLimit: null,
      overcurrentDuration: null,
      reaction: "Alarm",
      metrics: { current: 0, fuseState: "ok" },
    })),
  },
  "keypad-1": {
    type: "Controller",
    typeLabel: "CTRL",
    name: "cBerry Keypad CTRL-802",
    address: "0x30",
    category: "HMI",
    hw: "v1.0",
    firmware: "v1.0.0",
    status: "OK",
  },
  "analog-if": {
    type: "ADC",
    typeLabel: "IF",
    name: "cBerry Analog/Digital IF ADIF-641",
    address: "0x40",
    category: "Interface",
    hw: "v1.0",
    firmware: "v1.0.0",
    status: "OK",
    sensors: [
      createLevelSensor({ id: "analog-if-fresh", name: "Fresh Water", value: 75 }),
      createLevelSensor({ id: "analog-if-grey", name: "Grey Water", value: 40 }),
    ],
  },
  "bt-bridge": {
    type: "Bridge",
    typeLabel: "Bridge",
    name: "cBerry BT-Bridge BTC-1",
    address: "0xF0",
    category: "Gateway",
    hw: "v1.0",
    firmware: "v1.0.0",
    status: "OK",
  },
};

export function discoverMockNetwork() {
  const nodes = Object.entries(mockProfiles).map(([id, profile]) => ({
    id,
    name: profile.name,
    type: profile.type,
    typeLabel: profile.typeLabel || profile.type,
    address: profile.address,
    category: profile.category,
    status: profile.status || "OK",
    hw: profile.hw || "v1.0",
    fw: profile.firmware,
    updateAvailable: profile.status === "Needs Update",
    lastSeen: "just now",
    subtype: profile.subtype,
    channels: profile.channels,
  }));

  const devices = [];
  Object.values(mockProfiles).forEach((profile) => {
    if (profile.device) devices.push(profile.device);
    if (profile.sensors) devices.push(...profile.sensors);
  });

  return { nodes, devices };
}
